import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import {DataGridPro, GridToolbar} from '@mui/x-data-grid-pro';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import EditIcon from '@mui/icons-material/Edit'; 

export default function CrewsList(props){
    //console.debug("RTS Break CrewList");
 
    const history = useNavigate();

    const theme = useTheme();
    const smallForm = useMediaQuery(theme.breakpoints.down("sm"));

    
    function handleClick(e, cellValues){
        history("/CrewsEdit", {state: {idGuid:cellValues.row.idGuid, display:cellValues.row.name, mode:1}});
    }


    const columns = [
        {
            field: 'Edit',
            headerName: '',
            description:"Edit Crew", 
            flex:1,
            maxWidth:60,
            renderCell: (cellValues) => {
                return (
                    <Box sx={{display:'flex', alignItems:'center', justifyContent:'center', alignContent:'center', pt:.5}}>
                        <Link onClick={(event) => {handleClick(event, cellValues);}} sx={{textDecoration:'none', cursor:'pointer'}}>
                            <EditIcon />
                        </Link>
                    </Box>
                );
            },
            align:"center",
            sortable:false,
            filterable:false,
            hideable:false,
            disableColumnMenu:true
        },
        {
            field: 'name', 
            headerName: "Name", 
            description:"Crew Name", 
            flex:4,
            hideable:false,
        },
        {
            field: 'shortName', 
            headerName: "Short Name", 
            description:"Crew Short Name", 
            flex:4,
        },        
        {
            field: 'crewLeadName', 
            headerName: "Lead", 
            description:"Crew Lead Name", 
            flex:3        
        },
        {
            field: 'crewLeadPhoneNumber', 
            headerName: "Phone", 
            description:"Crew Lead Phone",
            flex:3    
        }, 
        {
            field: 'memberCount', 
            headerName: "Members", 
            description:"Number of Members",
            flex:1,
            type:"number"    
        },
        {
            field: 'createDate', 
            headerName: "Create Date", 
            description:"Create Date", 
            flex:2,           
            valueGetter: (value, row) => {
                if(value == null){
                    return '';
                }

                return (
                    new Date(value)
                );
            }, 
            type:'date',            
        },
        {
            field: 'createUser', 
            headerName: "Create User", 
            description:"User who created reel", 
            flex:3,         
        },     
        {
            field: 'modifyDate', 
            headerName: "Modify Date", 
            description:"Last Modify Date", 
            flex:2,           
            valueGetter: (value, row) => {
                if(value == null){
                    return '';
                }

                return (
                    new Date(value)
                );
            }, 
            type:'date',            
        },
        {
            field: 'modifyUser', 
            headerName: "Modify User", 
            description:"User who performed last modification", 
            flex:3,         
            hide:true                      
        },          
        

        {
            field: 'status', 
            headerName: "Status", 
            description:"Crew Status",
            flex:2,    
            valueGetter: (value, row) => {
                if(value === 1){
                    return ('Active');
                }
                else{
                    return('Disabled');
                }
            }, 
 
        }, 

    ];


    function getVisibilityModel(){
        if(smallForm){
            return {shortName:false, crewLeadPhoneNumber:false, notes:false, status:false, memberCount:false, createDate:false, createUser:false, modifyDate:false, modifyUser:false}
        }
        else{
            return {shortName:false, crewLeadPhoneNumber:false, notes:false, createDate:false, createUser:false, modifyDate:false, modifyUser:false}
        }
    };


    function getDensity(){
        if(smallForm){
            return "comfortable";
        }
        else{
            return "standard";
        }
    };


    return (
        <Box sx={{width:'100%', height:'100%', minHeight:'400px'}}>
            <DataGridPro
                pagination={true}
                slots={{toolbar: GridToolbar}}
                slotProps={{
                    toolbar:{
                        showQuickFilter:true,
                    }
                }}
                rows={props.data} 
                columns={columns} 
                getRowId={row => row.idGuid}
                initialState={{
                    columns:{
                        columnVisibilityModel: getVisibilityModel()
                    },
                    pagination: { paginationModel: { pageSize: 50 } },
                    density: getDensity() 

                }}                
            />
        </Box>
    );
}
